module.exports = require('./helpers/bundle-url').getBundleURL('ucbwC') + "logo-dark.ba5147f0.svg";